import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import { MdArrowBackIos, MdClose, MdDateRange, MdDownload, MdHistory, MdReport, MdUpload } from "react-icons/md";
import { Create_ledger_account } from "../ledger_accounts_root/Create_ledger_account.js";
import { PiBooks } from "react-icons/pi";
import Select_yes_no from "../../components_root/select_yes_no.jsx";
import Select_on_off from "../../components_root/select_on_off.jsx";
import Ledger_accounts_reports_profile from "../../company_root/staff_account_root/ledger_accounts_reports_profile.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Account_ledger() {
    const servicetablename = "accountingfinancedb";
    const [IsLoading2, setIsLoading2] = useState(true);
    const { Toastshow } = Toast();
    const [company, setCompany] = useState("");
    const [zero_balance, setZero_balance] = useState(true);
    const [isLoading_banner, setIsLoading_banner] = useState(true);
    const [reportsrdata, setReportsData] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        setIsLoading2(true);

        if (!select_company_uid) {
            console.error("No company selected");
            setIsLoading2(false);
            return;
        }

        const accountsQuery = query(
            collection(db, servicetablename, select_company_uid, "ledger_accounts"),
              where("usecase","==","master"),
           orderBy("date_time", "desc")
        );

        const unsubscribe = onSnapshot(
            accountsQuery,
            async (snapshot) => {
                try {
                    const accountDocs = snapshot.docs;

                    const results = await Promise.all(
                        accountDocs.map(async (accDoc) => {
                            const accData = accDoc.data();
                            // 🔹 Verify account type
                            let account_type = accData.account_type;

                            const masterRef = collection(
                                db,
                                "accounting_groups_list_master"
                            );
                            const masterQuery = query(
                                masterRef,
                                where("groupid", "==", accData.account_type)
                            );

                            const masterSnap = await getDocs(masterQuery);
                            if (!masterSnap.empty) {
                                account_type =
                                    masterSnap.docs[0].data()?.account_type ||
                                    accData.account_type;
                            }

                            const accNo = accData.accountguid;

                            const ledgerQuery = query(
                                collection(db, servicetablename, select_company_uid, "ledger_books"),
                                where("accountguid", "==", accNo),
                                orderBy("date_time", "desc"),
                                limit(1)
                            );

                            const ledgerSnap = await getDocs(ledgerQuery);

                            let lastLedger = null;
                            let balance = 0;

                            if (ledgerSnap.docs.length > 0) {
                                const data = ledgerSnap.docs[0].data();
                                balance = data.balance ?? 0;

                                lastLedger = {
                                    ledger_id: ledgerSnap.docs[0].id,
                                    ...data,
                                };
                            }

                            return {
                                id: accDoc.id,
                                ...accData,
                                account_type,
                                last_ledger: lastLedger,
                                last_ledger_date_time: lastLedger?.date_time,
                                sort_balance: balance,
                            };
                        })
                    );

                    // APPLY FILTER: 
                    // zero_balance == true → show all  
                    // else → show only balance > 0
                    const filteredResults = zero_balance
                        ? results
                        : results.filter((item) => item.sort_balance > 0);

                    // SORT: Highest balance first
                    const sortedData = filteredResults.sort(
                        (a, b) => b.sort_balance - a.sort_balance
                    );

                    setReportsData(sortedData);
                    setIsLoading2(false);
                } catch (err) {
                    console.error("Error:", err);
                    setIsLoading2(false);
                }
            },
            (error) => {
                console.error("Error fetching accounts:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    }, [zero_balance]);



    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const openEditVoucher = (uid) => {
        navigate(`?page=account_statement&accountguid=${uid}`);   // update URL

    };


    return (
        <div >
            <div className="items-back">
                <div className="b-bottom">
                    <table>
                        <tr>
                            <td ><div

                                className="button-ui0 text-h2 bold p-2"
                            >
                                <PiBooks className="icon" />Account Ledger
                            </div></td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="post-container p-11">

                    <table>
                        <tr><td><div className="text-h2 bold">Ledger show {reportsrdata.length}</div></td>
                            <td width={75}><Select_on_off checked={zero_balance} onChange={(e) => { setZero_balance(!zero_balance) }} /></td>
                        </tr>
                    </table>
                </div>
                <div className="post-container">


                    <div className="post_div">
                        <div className="ui-grid_voucher">

                            {IsLoading2 ? (
                                <></>
                            ) : reportsrdata.length === 0 ? (
                                <div className="text-h2 bold p-5">No oucher Found</div>
                            ) : (
                                <>
                                    {window.innerWidth > 768 ? (
                                        // ============================
                                        // DESKTOP VIEW: Single Row Table
                                        // ============================
                                        <table className="voucher-table-desktop ">
                                            <thead>
                                                <tr>
                                                    <th>AccountNo.</th>
                                                    <th>Date & Time</th>

                                                    <th>Name</th>
                                                    <th>Type</th>
                                                    <th>Balance</th>
                                                    <th>Withdrawal</th>
                                                    <th>Deposit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reportsrdata.map((row) => (

                                                    <tr key={row.accountguid} className="tr_hover">
                                                        <td width={70} title="Click: Account statement" onClick={() => openEditVoucher(row.accountguid)} className="cursor bold p-11 text-h3">{row.accountnumber || "0"}</td>
                                                        <td width={140} title="Click: Account statement" className="text-h3 cursor" onClick={() => openEditVoucher(row.accountguid)}>
                                                            {row.last_ledger_date_time?.toDate ? (
                                                                <>
                                                                    {row.last_ledger_date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.last_ledger_date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className="text-h3">Not Update</div>
                                                            )}
                                                        </td>

                                                        <td className="text-h2 fcap cursor " title="Click: Account statement" onClick={() => openEditVoucher(row.accountguid)}>{<Ledger_accounts_reports_profile accountguid={row.accountguid} />}</td>
                                                        <td width={80} className="text-h2"> <div
                                                            className={
                                                                `  text-h3 fcap` +
                                                                (row.account_type === "cash bold" ? "red" : "")
                                                            }
                                                        >
                                                            {row.account_type.replaceAll("_", " ")}
                                                        </div></td>
                                                        <td
                                                            width={80}
                                                            className="text-h2 bold"
                                                            style={{ color: (row?.last_ledger?.balance ?? 0) === 0 ? "#999" : "" }}
                                                        >
                                                            {row?.last_ledger?.balance == null
                                                                ? "--"
                                                                : Number(row.last_ledger.balance).toFixed(2)}
                                                        </td>

                                                        <td width={80}>
                                                            <div onClick={() => navigate("/?page=voucher_withdrawal&accountguid=" + row.accountguid)} className="button-ui red-back fcap p-11 cursor text-h2"><MdDownload className="icon" />Withdrawal</div>
                                                        </td>
                                                        <td width={80}>
                                                            <div
                                                                onClick={() => navigate("/?page=voucher_deposit&accountguid=" + row.accountguid)}
                                                                className="button-ui green-back fcap cursor p-11 text-h2"><MdUpload className="icon" />deposit</div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    ) : (
                                        // ============================
                                        // MOBILE VIEW: Card UI
                                        // ============================
                                        reportsrdata.map((row) => (
                                            <div
                                                className="ui-items items-back items-back b-1 m-1 p-11 shadow hover rounded "

                                                key={row.voucherid}
                                            >
                                                <table key={row.id}>
                                                    <tbody>
                                                        <tr>
                                                            <table>
                                                                <tr onClick={() => openEditVoucher(row.accountguid)} title="Click: Account statement"> <td>
                                                                    <div className="text-h1 bold">
                                                                        {row.name || "voucher No found"}
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr onClick={() => openEditVoucher(row.accountguid)} title="Click: Account statement"> <td>
                                                                    <div className="text-h3">Mobile:
                                                                        {row.mobile || "No  found"}
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr> <td>
                                                                    <div className="text-h3 text-off ">
                                                                        {row.description || "No  found"}
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr> <td>
                                                                    <table onClick={() => openEditVoucher(row.accountguid)} title="Click: Account statement">
                                                                        <tr>
                                                                            <td>
                                                                                <div
                                                                                    className={
                                                                                        ` bold text-h2 fcap ` +
                                                                                        (row.account_type === "cashier" ? "red" : "")
                                                                                    }
                                                                                >
                                                                                    {row.account_type}
                                                                                </div>
                                                                            </td>
                                                                            <td><div className="text-h3 ">A/c:
                                                                                {row.accountguid || "No  found"}
                                                                            </div></td>
                                                                        </tr>
                                                                    </table>
                                                                </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>

                                                                        <table className="b-top">
                                                                            <tr>
                                                                                <td
                                                                                    width={80}
                                                                                    className="text-h2 bold"
                                                                                    style={{ color: (row?.last_ledger?.balance ?? 0) === 0 ? "#999" : "" }}
                                                                                >
                                                                                    {row?.last_ledger?.balance == null
                                                                                        ? "--"
                                                                                        : Number(row.last_ledger.balance).toFixed(2)}
                                                                                </td>
                                                                                 <td width={140} title="Click: Account statement" className="text-h3 cursor" onClick={() => openEditVoucher(row.accountguid)}>
                                                            {row.last_ledger_date_time?.toDate ? (
                                                                <>
                                                                    {row.last_ledger_date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.last_ledger_date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className="text-h3">Not Update</div>
                                                            )}
                                                        </td>

                                                                            </tr>
                                                                        </table>

                                                                    </td>
                                                                </tr>

                                                            </table>



                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table className="table-fixed">
                                                    <tr>
                                                        <td>
                                                            <div onClick={() => navigate("/?page=voucher_withdrawal&accountguid=" + row.accountguid)} className="button-ui fill red-back fcap p-1 cursor text-h2"><MdDownload className="icon" /> withdrawal</div>
                                                        </td>
                                                        <td>
                                                            <div
                                                                onClick={() => navigate("/?page=voucher_deposit&accountguid=" + row.accountguid)}
                                                                className="button-ui fill green-back fcap cursor p-1 text-h2"><MdUpload className="icon" />deposit</div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        ))
                                    )}
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </div>

        </div>
    );
}
